import type { QuoteRestriction } from "@freightsimple/generated-dashboard-openapi-client/models/QuoteRestriction";
import type { DialogBaseProps } from "@freightsimple/ui-core/Dialog/DialogBaseProps";
import { BulletList } from "@freightsimple/ui-core/Typography/BulletList";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";

interface BookShipmentConfirmRestrictionsDialogProps extends DialogBaseProps {
  restrictions: QuoteRestriction[];
  /** Fired when the customer acknowledges the restrictions. */
  onConfirmed: () => void;
}

// Shown before booking a quote that carries service restrictions — the
// customer must acknowledge them. Replaces the legacy imperative modal.
export function BookShipmentConfirmRestrictionsDialog(
  props: BookShipmentConfirmRestrictionsDialogProps,
) {
  return (
    <Dialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title="Review Restrictions"
      description="Please confirm you are aware of the following restrictions:"
      width="narrow"
      footer={
        <>
          <Button size="large" onClick={() => props.onOpenChange?.(false)}>
            Cancel
          </Button>
          <Button
            primary
            size="large"
            onClick={() => {
              props.onOpenChange?.(false);
              props.onConfirmed();
            }}
          >
            I Understand
          </Button>
        </>
      }
    >
      <ControlPresentationProvider presentation="underlined">
        <Stack gap={4} align="start">
          <BulletList>
            {props.restrictions.map((r) => (
              <li key={r.description}>
                <T size="base" color="secondary">
                  {r.description}
                </T>
              </li>
            ))}
          </BulletList>
          <T size="base" color="secondary">
            Additional charges may apply if these service restrictions are not
            met.
          </T>
        </Stack>
      </ControlPresentationProvider>
    </Dialog>
  );
}
